import { render, staticRenderFns } from "./LoansClosed.vue?vue&type=template&id=0dece194"
import script from "./LoansClosed.vue?vue&type=script&lang=js"
export * from "./LoansClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports